"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypographyProvider = void 0;
const styled_components_1 = require("styled-components");
const TypographyProvider = (0, styled_components_1.createGlobalStyle) `
  @font-face {
    font-family: 'Montserrat';
    src: url('https://cdn.carlsberggroup.com/fonts/montserrat/Montserrat-VF.woff2') format('woff2'),
         url('https://cdn.carlsberggroup.com/fonts/montserrat/Montserrat-VariableFont_wght.ttf') format('truetype');
    font-display: 'swap';
    font-weight: 400 900;
    font-stretch: 100%;
  }
`;
exports.TypographyProvider = TypographyProvider;
//# sourceMappingURL=TypographyProvider.js.map